/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withTranslation } from 'react-i18next'
import styles from './AddressUpdateQuestion.module.scss'
import { useHistory } from 'react-router-dom'
import { addressUpdateAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import BackAnchor from '../../../../shared/components/BackAnchor'

const AddressUpdateQuestionView = ({ t, i18n }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const { editFromConfirmation } = useSelector((state) => state.app)

  const handleYes = () => {
    dispatch(addressUpdateAction(true));
    if (editFromConfirmation) {
      history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
    }
    else {
      history.push(`/${i18n.language}${t('routes.your_info')}`)
    }

  }

  const handleNo = () => {
    dispatch(addressUpdateAction(false));
    if (editFromConfirmation) {
      history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
    }
    else {
      history.push(`/${i18n.language}${t('routes.your_info')}`)
    }
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('address_update_question.have_you_recently')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h3>{t('address_update_question.in_the_last_two')}</h3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <button className={'btn-lg btn-default'} onClick={handleYes} value={t('address_update_question.yes')} name={t('address_update_question.yes')}>
            {t('address_update_question.yes')}
          </button>
          <button
            className={['btn-lg btn-default', styles['margin_left_20']].join(' ')}
            onClick={handleNo}
            value={t('address_update_question.no')}
            name={t('address_update_question.no')}
          >
            {t('address_update_question.no')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(AddressUpdateQuestionView)
